import React, { useEffect } from 'react';

export default function LightboxModal({ images, currentIndex, isOpen, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !images || images.length === 0) return null;

  const currentImg = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 animate-fade-in backdrop-blur-xs">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-neutral-300 text-3xl font-bold p-2 z-10 transition-colors"
        aria-label="Luk visning"
      >
        <i className="fa-solid fa-xmark"></i>
      </button>

      {/* Counter */}
      <div className="absolute top-4 left-4 text-white/80 text-sm font-medium bg-black/40 px-3 py-1 rounded">
        {currentIndex + 1} / {images.length}
      </div>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 text-white hover:text-neutral-300 text-3xl p-3 z-10 transition-colors bg-black/30 hover:bg-black/60 rounded-full"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      )}

      {/* Image display */}
      <div className="max-w-5xl max-h-[85vh] flex items-center justify-center overflow-hidden">
        <img
          src={typeof currentImg === 'string' ? currentImg : currentImg?.src || currentImg?.url}
          alt={currentImg?.alt || currentImg?.title || 'Billede'}
          className="max-w-full max-h-[85vh] object-contain rounded shadow-2xl transition-all"
        />
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 text-white hover:text-neutral-300 text-3xl p-3 z-10 transition-colors bg-black/30 hover:bg-black/60 rounded-full"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right"></i>
        </button>
      )}
    </div>
  );
}
